import { render } from "./TransporteDonut.vue?vue&type=template&id=3cc7f272&scoped=true"
import script from "./TransporteDonut.vue?vue&type=script&lang=js"
export * from "./TransporteDonut.vue?vue&type=script&lang=js"

import "./TransporteDonut.vue?vue&type=style&index=0&id=3cc7f272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc7f272"]])

export default __exports__